// Libraries
import React, { useContext } from "react";

// Components
import { IonList, IonRouterLink } from "@ionic/react";

// Font Awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Styling
import moment from "moment";
import { AuthenticatedUserContext } from "../../../contexts/AuthenticatedUserContext";
import "./DesktopNav.scss";

// Utilities
import { NavItems } from "../../../utils";

const DesktopNav = () => {
  const { member } = useContext(AuthenticatedUserContext);
  const isApproved = moment(member?.approved_at).isBefore();

  if (!isApproved) return null;

  const navItems = NavItems();

  return (
    <nav className={"desktop-nav"}>
      <IonList className="desktop-nav__list">
        {navItems
          .filter((navItem) => navItem.desktop)
          .map((navItem, key) => (
            <IonRouterLink key={key} tabIndex={-1} routerLink={navItem.url} className={["desktop-nav__link", navItem.active ? "desktop-nav__link--active" : ""].join(" ")}>
              <FontAwesomeIcon icon={navItem.icon} className="desktop-nav__link__icon" />
              <span>{navItem.title}</span>
            </IonRouterLink>
          ))}
      </IonList>
    </nav>
  );
};

export default DesktopNav;
